export default {
  data () {
    return {
      tableLoading: false,
      page_num: 1,
      page_size: 10,
      total: 0
    }
  },
  methods: {
    handlePageChange (page) {
      this.page_num = page
      this.getTableData()
    },
    handleSizeChange (size) {
      console.log(size)
      this.page_size = size
      this.page_num = 1
      this.getTableData()
    }
  }
}
